import styled from 'styled-components'
import { useEffect } from 'react'
import { useState } from 'react'

interface PasswordStrength {
  password: string
}

const errMsgs = [
  {
    msg: 'Password must include an upper case',
    code: 'must_include_uppercase',
  },
  {
    msg: 'Password must include a special case',
    code: 'must_include_special_character',
  },

  {
    msg: 'Password must include a number',
    code: 'must_include_number',
  },
  {
    msg: 'Password must be a minimum of 8 digits',
    code: 'password_length',
  },
]

const passwordCheck = (code: string, password: string): boolean | undefined => {
  if (!password) {
    return undefined
  }
  switch (code) {
    case 'must_include_uppercase':
      const uppercaseRegex = new RegExp('(?=.*[A-Z])')
      return uppercaseRegex.test(password)
    case 'must_include_special_character':
      const specialChars = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
      return specialChars.test(password)
    case 'must_include_number':
      const hasNumber = new RegExp('(?=.*[0-9])')
      return hasNumber.test(password)
    case 'password_length':
      const length = new RegExp('(?=.{8,})')
      return length.test(password)
    default:
      break
  }
}

const PasswordStrengthIndicator = ({ password }: PasswordStrength) => {
  const [pwd, setPwd] = useState(password)
  useEffect(() => {
    setPwd(password)
  }, [password])

  if (!pwd) {
    return null
  }

  return (
    <Container>
      {errMsgs.map((item) => {
        return (
          <TextIndicator key={item.code} valid={passwordCheck(item.code, pwd)}>
            - {item.msg}
          </TextIndicator>
        )
      })}
    </Container>
  )
}
export { PasswordStrengthIndicator }

const Container = styled.div`
  margin-top: 18px;
`

const TextIndicator = styled.p<{ valid?: boolean | undefined }>`
  color: ${({ theme, valid }) => (valid ? '#828282' : theme.colors.red)};
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
`
